<div class="upload-frame mat-elevation-z8">
  <app-header [componentName]="compName" (searchClick)="search($event)" (iconClick)="searchIconClick($event)"
    (filterClick)="loadFilterData($event)"></app-header>
  <div class="spinner-Overlay" *ngIf="displaySpinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div *ngIf="caseCount == 0">
    <p class="no-upload">{{ "CaseHistory.NoData" | translate }}</p>
  </div>
  <div [ngStyle]="
      totalRec > 0 ? { visibility: 'visible' } : { visibility: 'hidden' }
    ">
    <cdk-virtual-scroll-viewport itemSize="50" class="table-container" [ngClass]="{ expandedTable: expandTable }">
      <table mat-table [dataSource]="dataSource" matSort matSortDisableClear matSortActive="dueDateTime"
        matSortDirection="asc" (matSortChange)="sortTable($event)" aria-describedby="myCase" class="mrg-t">
        <ng-container matColumnDef="icons">
          <th mat-header-cell id="icon" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="my-cases-icons">
              <div [ngClass]="{
                'notification-icon-red': element.overDueFlag,
                'notification-icon-green': !element.overDueFlag}">
              </div>
              <div class="infoIcons" *ngIf="reviewerFlag">
                <span>
                  <img *ngIf="(element.caseStatus === statusInProgress || element.caseStatus ===  statusProcessing || element.caseStatus === statusApproved)" id="MyCases.patientDescription" alt="{{ 'MyCases.infoIcon' | translate }}"
                  title="{{ 'MyCases.infoIcon' | translate }}" src="assets\images\informattion.svg"
                  (click)="viewCaseDetails(element)" />
                </span>
                <span>
                  <img *ngIf="(element.caseStatus == statusRejected) || (element.caseStatus == statusError)" id="MyCases.patientDescription"
                  src="assets\images\bx_error-alt.svg" alt=" {{ 'MyCases.error' | translate }}"
                  title=" {{ 'MyCases.error' | translate }}" (click)="viewCaseDetails(element)" />
                </span>
              </div>
          </td>
        </ng-container>
        <!-- Case ID -->
        <ng-container matColumnDef="caseId">
          <th mat-header-cell id="caseId" *matHeaderCellDef>
            {{ "MyCases.caseID" | translate }}
          </th>
          <td class="alignColumns" mat-cell *matCellDef="let element">{{ element.caseId }}</td>
        </ng-container>
        <ng-container matColumnDef="anatomy">
          <th mat-header-cell id="anatomy" *matHeaderCellDef>
            {{ "MyCases.anatomy" | translate }}
          </th>
          <td mat-cell class="anatomyAlign" *matCellDef="let element">{{ element.anatomy | titlecase }}</td>
        </ng-container>
        <ng-container matColumnDef="imagingType">
          <th mat-header-cell id="imagingType" *matHeaderCellDef>
            {{ "MyCases.type" | translate }}
          </th>
          <td mat-cell class="anatomyAlign" *matCellDef="let element">{{ element.imagingType }}</td>
        </ng-container>
        <ng-container matColumnDef="caseStatus">
          <th mat-header-cell id="caseStatus" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by caseStatus">
            {{ "MyCases.status" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="statusAlignColumn">
              <span [ngClass]="[reviewerFlag ? 'alignFlag' : '']" *ngIf="element.overDueFlag && (element.caseStatus != statusApproved)">
                <img
                  src="..\assets\images\redflag.svg"
                  id="redFlag"
                  alt=" {{ 'ActiveCase.redflag' | translate }}"
                  title="{{ 'ActiveCase.redflag' | translate }}"
                />
              </span>
              <span [ngClass]="[reviewerFlag ? 'alignFlag' : '']" *ngIf="!element.overDueFlag">
                &nbsp;
              </span>
              <div [ngClass]="{'status_width':element.overDueFlag && (element.caseStatus == statusApproved)}" *ngIf="element.overDueFlag && (element.caseStatus == statusApproved)">  
              </div>
              <span title = "{{element.caseStatus}}" class="caseStatusTextAlign">
                {{ element.caseStatus | titlecase }}
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="updateDateTime">
          <th mat-header-cell id="updateDateTime" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by updateDateTime">
            {{ "MyCases.completedDate" | translate }}
          </th>

          <td mat-cell class="datesAlign" *matCellDef="let element">
            {{
              element.caseStatus === statusInProgress
              ? "-"
              : (element.updateDateTime | localtimezone)
              }}
          </td>
        </ng-container>
        <ng-container matColumnDef="dueDateTime">
          <th mat-header-cell id="dueDateTime" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by dueDateTime">
            {{ "MyCases.dueDate" | translate }}
          </th>
          <td mat-cell class="datesAlign" *matCellDef="let element">
            {{ element.dueDateTime | localtimezone }}
          </td>
        </ng-container>
        <ng-container matColumnDef="timeDifference">
          <th mat-header-cell id="timeDifference" *matHeaderCellDef mat-sort-header sortActionDescription="Sort by timeDifference">
            {{ "MyCases.timeUntilDue" | translate }}
          </th>
          <td mat-cell class="datesAlign" *matCellDef="let element" [ngClass]="{
              moreThanOneDay: element.dueTimeFlag,
              oneDayDueStat: element.oneDayUntilDue,
              overDueStat: element.overDueFlag
            }">
            {{
            element.caseStatus === statusApproved ||
            element.caseStatus === statusRejected ||
            element.caseStatus === statusError
            ? "-"
            : element.reviewTime
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actionsClaim">
          <th mat-header-cell id="actionsClaim" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element; let i = dataIndex">
            <div class="actionsClaim">            
            <span>
              <button class="claimBtn font-SN-core"
              [ngClass]="(element.caseStatus === statusApproved || element.caseStatus ===  statusRejected || element.caseStatus === statusError)
                ? 'btn-hidden br-4 mt-2': 'btn-disabled br-4 mt-2' " mat-button>
              {{ "MyCases.claim" | translate }}
            </button>
            </span>
            <span>
              <button class="case-management-button btn-SN-default font-SN-core" *ngIf="(element.caseStatus == statusApproved || element.caseStatus == statusRejected)" mat-button (click)="navigateMRI(element.caseId, element.caseStatus)">
                {{ "MyCases.view" | translate }}
              </button>
              <button class="case-management-button btn-SN-default font-SN-core" *ngIf="(element.caseStatus == statusInProgress || element.caseStatus == statusProcessing)" mat-button (click)="navigateMRI(element.caseId, element.caseStatus)">
                {{ "MyCases.open" | translate }}
              </button>
            </span>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr class="cursor-pointer" mat-row *matRowDef="let listItem; columns: displayedColumns" [ngClass]="{
            hovered: listItem.hovered,
            highlighted: selectedRowIndex == listItem.caseId
          }" (click)="highlightRow(listItem)" (mouseover)="listItem.hovered = true"
          (mouseout)="listItem.hovered = false"></tr>
      </table>
      <!-- Show more Button -->
    <button *ngIf="
    !(totalPages == myCasesData.page + 1) &&
    myCasesDetailsRes &&
    totalRec > 0
  " class="show-more-button btn-SN-primary font-16 br-4" (click)="showMore()">
  {{ "MyCases.showMore" | translate }}
    </button>
    </cdk-virtual-scroll-viewport>
  </div>
</div>